import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageStateService } from '../services/language-state.service';

export const LanguageInterceptor: HttpInterceptorFn = (req, next) => {
  // No añadir el header en las peticiones de traducciones o assets
  if (
    req.url.startsWith('/i18n/') ||
    req.url.includes('/assets/') ||
    req.url.includes('.json') ||
    req.url.includes('/temp/')
  ) {
    return next(req);
  }

  const languageService = inject(LanguageStateService);
  const currentLang = languageService.activeLanguage()?.code;

  if (!currentLang) return next(req);

  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Language': currentLang,
    },
  });
  return next(modifiedReq);
};
